import PropTypes from 'prop-types';
import React from 'react';

const AutomationSection = ({ section, children }) => (
  <section className="automation-rules__section" aria-labelledby={`${section.id}-heading`}>
    <h3 className="automation-rules__section-title" id={`${section.id}-heading`}>
      {section.title}
    </h3>
    <p className="automation-rules__section-subtitle">{section.subtitle}</p>
    {children}
  </section>
);

AutomationSection.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

AutomationSection.defaultProps = { children: null };

export default AutomationSection;
